export default __webpack_public_path__ + "static/GRID22-map-youth-b24cb81b5a735fca00e74243fe905d2f.png";